export const socialLinks = {
  twitter: 'https://twitter.com/',
  discord: 'https://discord.com/',
  github: 'https://discord.com/',
};

export const featuresLinks = {
  antiWebHook: 'https://discord.com/',
  antiSpam: 'https://discord.com/',
  verivication: 'https://discord.com/',
  antiNuke: 'https://discord.com/',
  fakeDetection: 'https://discord.com/',
  antiRaid: 'https://discord.com/',
  documentation: 'https://discord.com/',
};
